"use strict";
import ApiService from "../services/api_service";
var AlertArea = React.createClass({
  componentWillMount: function() {
    $(ApiService).on("ApiService:alertError", this.showAlert);
  },
  componentWillUnmount: function() {
    $(ApiService).off("ApiService:alertError", this.showAlert);
  },
  showAlert: function(event, errorObject) {
    this.setState({
      alertShowing: true,
      alertMessage: errorObject.message,
      alertDetails: errorObject.details ? _.extend(errorObject.details, { location: window.location }) : null,
      alertType: errorObject.type === void 0 ? "alert" : errorObject.type
    });
  },
  getInitialState: function() {
    return {
      alertShowing: false
    };
  },
  closeAlert: function() {
    this.setState({ alertShowing: false });
  },
  errorText: function() {
    return "Please describe what you were doing above this line.\n----------------------------------\n\n" + btoa(JSON.stringify(this.state.alertDetails));
  },
  details: function() {
    if (this.state.viewingDetails) {
      const supportEmail = Auth._currentUser.account.settings.processor_support_email_address;
      const supportMessage = supportEmail ? "an email to" : "a support ticket at";
      const supportUrl = supportEmail ? `mailto:${supportEmail}` : "https://support.triumphpay.com/support/tickets/new";
      const target = supportEmail ? null : "_blank";
      const supportText = supportEmail ? supportEmail : "TriumphPay Support";
      return /* @__PURE__ */ React.createElement("div", { className: "alert-box__error-details" }, /* @__PURE__ */ React.createElement("h3", null, "Error Details"), /* @__PURE__ */ React.createElement("p", null, "Copy and paste this information into ", supportMessage, " ", /* @__PURE__ */ React.createElement("a", { href: supportUrl, target }, supportText), ":"), /* @__PURE__ */ React.createElement("textarea", { value: this.errorText(), rows: "12" }));
    }
  },
  notifySupportLink: function() {
    if (!this.state.viewingDetails && !_.isEmpty(this.state.alertDetails)) {
      return /* @__PURE__ */ React.createElement(
        "a",
        {
          className: "alert-box__support-link",
          onClick: this.viewDetails
        },
        "View Details."
      );
    }
  },
  viewDetails: function() {
    this.setState({ viewingDetails: true });
  },
  alertBox: function() {
    if (this.state.alertShowing) {
      return /* @__PURE__ */ React.createElement("div", { className: "alert-row row" }, /* @__PURE__ */ React.createElement("div", { className: "alert-box " + this.state.alertType + " radius" }, this.state.alertMessage, "\xA0", this.notifySupportLink(), this.details(), /* @__PURE__ */ React.createElement("a", { onClick: this.closeAlert, className: "close" }, "\xD7")));
    }
  },
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { id: "alert-area" }, this.alertBox());
  }
});
export default AlertArea;
